import { logException } from "@util/errors";
import { dynamicScriptLoad } from "./utils.js";

type gTagFunction = (
  type: string,
  eventName: string | Date,
  eventParams?: { [key: string]: string },
) => void;

type GoogleAnalyticsWindow = Window & {
  dataLayer?: IArguments[];
  gtag?: gTagFunction;
};

const getGoogleAnalyticsWindow = (): GoogleAnalyticsWindow => window;

export function initGoogleAnalytics(debug: boolean) {
  if (!hasGaLoaded()) {
    dynamicScriptLoad(
      `https://www.googletagmanager.com/gtag/js?id=UA-116626517-5`,
    );
    // Initialize the dataLayer and gtag function
    const gaWindow = getGoogleAnalyticsWindow();
    gaWindow.dataLayer = gaWindow.dataLayer || [];
    gaWindow.gtag = function () {
      // Google gtag's bootstrap snippet queues the real Arguments object.
      gaWindow.dataLayer?.push(arguments);
    };

    const gtag = gaWindow.gtag;
    if (hasGaLoaded() && gtag) {
      gtag("js", new Date());
      gtag("config", "UA-116626517-5");
      gtag("config", "AW-360844917");
    }
    if (debug) {
      console.debug(`[GoogleAnalytics] loaded`);
    }
  }
}

export function captureGoogleAnalyticsConversion(debug?: boolean) {
  const gtag = getGoogleAnalyticsWindow().gtag;
  if (hasGaLoaded() && gtag) {
    try {
      gtag("event", "conversion", {
        send_to: "AW-360844917/WcUTCJO6ysQCEPWciKwB",
      });
    } catch (err) {
      logException(err);
    }
    if (debug) {
      console.debug("[GoogleAnalytics] conversion event");
    }
  }
}

function hasGaLoaded(): boolean {
  const ga = getGoogleAnalyticsWindow().gtag;
  return ga !== undefined;
}
